"use client";
import { wowAnimation } from "@/utils";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap");
}

type IProps = {
  children: React.ReactNode;
};

export default function MainProvider({ children }: IProps) {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  const pathname = usePathname();
  useEffect(() => {
    if (!isMobile) {
      wowAnimation();
    }
  }, [pathname]);
  return children;
}
